import cx from 'clsx';
import * as React from 'react';

import { IChatHintSchema } from 'shared/repositories/chats/entities/chat_hint/ChatHintSchema';

import { HintQuestionItemSlider } from './HintQuestionItemSlider';
import * as styles from './HintQuestionsSlider.css';

type THintQuestionsSliderProps = {
  hintQuestions: IChatHintSchema[];
  onClick(text: string): void;
};

export const HintQuestionsSlider: React.FC<THintQuestionsSliderProps> = ({ hintQuestions, onClick }) => {
  return (
    <div className={cx(styles['container'])}>
      <div className={cx(styles['gallery-container'])}>
        <div className={cx(styles['gallery'])}>
          {hintQuestions.map(({ buttonText }, index) => (
            <HintQuestionItemSlider key={index} onClick={onClick} text={buttonText} />
          ))}
        </div>
      </div>
    </div>
  );
};
